import React from 'react'
    import { BrowserRouter as Router, Routes, Route } from 'react-router-dom'
    import { Toaster } from 'react-hot-toast'
    import Navbar from './components/Navbar'
    import Footer from './components/Footer'
    import HomePage from './pages/HomePage'
    import ContactPage from './pages/ContactPage'
    import PrivacyPage from './pages/PrivacyPage'
    import TermsPage from './pages/TermsPage'

    function App() {
      return (
        <Router>
          <div className="min-h-screen bg-white" data-component-path="client/src/App.jsx" data-component-line="1:4" data-component-id="client/src/App.jsx:1:4">
            <Navbar />
            <main data-component-path="client/src/App.jsx" data-component-line="2:6" data-component-id="client/src/App.jsx:2:6">
              <Routes>
                <Route path="/" element={<HomePage />} />
                <Route path="/contact" element={<ContactPage />} />
                <Route path="/privacy" element={<PrivacyPage />} />
                <Route path="/terms" element={<TermsPage />} />
              </Routes>
            </main>
            <Footer />
            <Toaster position="top-right" />
          </div>
        </Router>
      )
    }

    export default App